import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import { useInfoCeldas } from './InfoCeldasContext';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

export default function TabIndi() {
    const { intervalo, setIntervalo } = useInfoCeldas();

    const handleChange = (event, newValue) => {
        setIntervalo(newValue);
    };

    return (
        <div className="static1">
            <AppBar position="static">
                <Tabs value={intervalo} onChange={handleChange}>
                    <Tab label="Corrida" />
                    <Tab label="Acumulado día" />
                </Tabs>
            </AppBar>
        </div>
    );
}
